import { render } from "./SelectPickup.vue?vue&type=template&id=7c1c7762"
import script from "./SelectPickup.vue?vue&type=script&lang=js"
export * from "./SelectPickup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__